import { DataTestIds } from '@repo/frontend-shared';
import { SDSButton } from '@repo/sds/SDSButton';
import { SDSFlexbox } from '@repo/sds/SDSFlexbox';

interface FormActionButtonsProps {
  onCancel?: () => void;
  submitButtonLabel?: string;
  secondarySubmitButtonLabel?: string;
  secondarySubmitHandler?: () => void;
  /** Either submit is in flight — disables Cancel so it can't abandon either one mid-flight. */
  isSubmitting: boolean;
  /** This form's own primary-vs-secondary split of `isSubmitting`, so only the button actually
   * submitting shows its own spinner while the other one is disabled instead. */
  isPrimarySubmitting: boolean;
  isSubmitDisabled?: boolean;
  isSecondarySubmitting: boolean;
  isSecondarySubmitDisabled?: boolean;
  submitBtnTestId?: string;
  isFullWidth: boolean;
}

export function FormActionButtons({
  onCancel,
  submitButtonLabel,
  secondarySubmitButtonLabel,
  secondarySubmitHandler,
  isSubmitting,
  isPrimarySubmitting,
  isSubmitDisabled,
  isSecondarySubmitting,
  isSecondarySubmitDisabled,
  submitBtnTestId,
  isFullWidth,
}: FormActionButtonsProps) {
  if (!(onCancel || submitButtonLabel || secondarySubmitButtonLabel)) return null;

  return (
    <SDSFlexbox gap="content-default" justifyContent="flex-end" wrap="wrap" fullWidth>
      {onCancel && (
        <SDSButton
          text="Cancel"
          isFullWidth={isFullWidth}
          isDisabled={isSubmitting}
          onClick={onCancel}
          mode="outline"
          ariaLabel="Cancel form submission"
        />
      )}
      {submitButtonLabel && (
        <SDSButton
          dataTestId={submitBtnTestId ?? DataTestIds.TEXT_INPUT.FORM_SUBMIT_BTN}
          type="submit"
          text={submitButtonLabel}
          isFullWidth={isFullWidth}
          isSubmitting={isPrimarySubmitting}
          isDisabled={isPrimarySubmitting ? false : Boolean(isSubmitDisabled) || isSecondarySubmitting}
          ariaLabel={submitButtonLabel}
          ariaBusy={isPrimarySubmitting}
        />
      )}
      {secondarySubmitButtonLabel && secondarySubmitHandler && (
        <SDSButton
          type="button"
          text={secondarySubmitButtonLabel}
          isFullWidth={isFullWidth}
          isSubmitting={isSecondarySubmitting}
          isDisabled={isSecondarySubmitting ? false : Boolean(isSecondarySubmitDisabled) || isPrimarySubmitting}
          onClick={secondarySubmitHandler}
          ariaLabel={secondarySubmitButtonLabel}
          ariaBusy={isSecondarySubmitting}
        />
      )}
    </SDSFlexbox>
  );
}
